import TeamReportDataRow from "./TeamReportDataRow";

export default TeamReportDataRow;
